module.exports = __webpack_public_path__ + "static/media/5.12f10dc4.jpg";